import "./form-agent.scss";

import { AgentFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = AgentFormSchema;
export function FormAgent() {
  const { control } = useFormContext<AgentFormSchema>();

  return (
    <div id="FormAgent" className="agent">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="email"
        label="Email"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter email"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="address"
        label="Address"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter address"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="contactNumber"
        label="Contact Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter contactNumber"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="markupPercentage"
        label="Markup Percentage"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter markupPercentage"
      />
    </div>
  );
}

export default FormAgent;
